import React from 'react'
import { Link } from 'react-router-dom'
import moment from 'moment'
import { formatDecimals, formatLocal } from 'utils'
import { AddressLink, TruncateAddress, TruncateTxn } from 'components/Utils'
import { AccountTxnAction } from 'entities/AccountTransaction'
import { CNR, CNS } from 'constants/tokens'

const AccountTxnsTableColumns = [
  {
    title: 'Txn Hash',
    dataIndex: 'txid',
    width: 180,
    render: (txid) => (
      <Link to={`/transaction/${txid}`}>
        <TruncateTxn address>{txid}</TruncateTxn>
      </Link>
    ),
  },
  {
    title: 'Age',
    dataIndex: 'date',
    render: (date) => moment.unix(date).fromNow(),
    width: 140,
  },
  {
    title: 'From',
    dataIndex: 'from',
    render: (from) => (
      <AddressLink address={from}>
        <TruncateAddress address>{from}</TruncateAddress>
      </AddressLink>
    ),
  },
  {
    title: 'To',
    dataIndex: 'to',
    render: (to) => (
      <AddressLink address={to}>
        <TruncateAddress address>{to}</TruncateAddress>
      </AddressLink>
    ),
  },
  {
    title: 'Status',
    dataIndex: 'status',
    render: (confirmed) => (confirmed === 'SUCCESS' ? <span>SUCCESS</span> : <span>FAILED</span>),
  },
  {
    title: 'Action',
    dataIndex: 'action',
    render: (action) => {
      if (action === AccountTxnAction.CONVERTTORISE) {
        return 'CONVERT TO RISE'
      }
      if (action === AccountTxnAction.CONVERTTOSWAP) {
        return 'CONVERT TO SWAP'
      }
      return action
    },
  },
  {
    title: 'Direction',
    dataIndex: 'direction',
  },
  {
    title: 'Amount',
    dataIndex: 'amount',
    render: (quant, record) => {
      const tokenName = record.token === CNR.symbol ? CNR.shortName.toLowerCase() : CNS.shortName.toLowerCase()
      return (
        <span>
          {formatLocal(formatDecimals(quant, 8), 2)}&nbsp;
          <Link to={`/tokens/${tokenName}`}>{record.token}</Link>
        </span>
      )
    },
    width: 180,
  },
]

export default AccountTxnsTableColumns
